import Lozenge from '@atlaskit/lozenge';
import { getLozengeAppearance } from '@databases/tag/select-option-appearance';
import React from 'react';

import styles from './select-option-lozenge.module.css';

type SelectOptionLozengeProps = {
  readonly label: string;
  readonly color: string;
  readonly testId: string;
  readonly showDisabledValue: boolean;
};

/**
 * Read-only presentation stays independent of the production interactive Tag wrappers.
 */
export function SelectOptionLozenge({
  label,
  color,
  testId,
  showDisabledValue
}: SelectOptionLozengeProps) {
  return (
    <span className={styles.container} data-disabled={showDisabledValue || undefined}>
      <Lozenge appearance={getLozengeAppearance(color)} maxWidth="180px" testId={testId}>
        <span className={styles.content}>
          <span className={styles.label}>{label}</span>
        </span>
      </Lozenge>
    </span>
  );
}
